import { useMutation } from '@tanstack/react-query';
import { fetchJson } from '@/utils/apiFetch';
import type {
  CandidateProfilePostRequest,
  CandidateProfileResponse,
} from '../types/CandidateProfile';

export default function usePostCandidateProfile() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({
      name,
      organization_user_ids,
      custom_data,
      document_blob_signed_ids,
    }: CandidateProfilePostRequest) => {
      // response.ok を見ずに body を返すと 404/422 でも id が undefined のまま成功扱いになり、作成しましたトーストの後 /agent/candidates/undefined へ遷移して 404 画面になる
      return fetchJson<CandidateProfileResponse>(`/agent/api/candidate_profiles`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({
          name,
          organization_user_ids,
          custom_data,
          // 書類から作成モード: 解析済みblobのsigned_idを渡してdocument_filesにアタッチする
          ...(document_blob_signed_ids?.length ? { document_blob_signed_ids } : {}),
        }),
      });
    },
  });
}
